<template>
    <div id="content" class="cf site-content">
        <div id="primary" class="full-width-page">
            <main id="main" class="site-main" role="main">
                <article id="post-14" class="post-14 page type-page status-publish hentry">
                    <header class="entry-header">
                    </header>
                    <!-- .entry-header -->
                    <div class="entry-content">
                        <div id="pl-14" class="panel-layout">
                            <div id="pg-14-0" class="panel-grid panel-no-style">
                                <div id="pgc-14-0-0" class="panel-grid-cell">
                                    <div id="panel-14-0-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="0">
                                        <div class="textwidget">
                                            <h1><span class="" style="display:block;clear:both;height: 0px;padding-top: 10px;border-top-width:0px;border-bottom-width:0px;"></span></h1>
                                            <h1 style="text-align: center;" v-html="title"></h1>
                                            <hr>
                                            <p>&nbsp;</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="pg-14-1" class="panel-grid panel-no-style">
                                <div id="pgc-14-1-0" class="panel-grid-cell">
                                    <div id="panel-14-1-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="1">
                                        <div class="textwidget" v-html="content">
   <!--                                          <p><font color="#089afc">At KPKitchen</font>, we believe that the family is the most important thing in life and every mom loves to put a smile on her child’s face, even if it's with some small self-made pastries. We serve busy moms who still take the time to bake for their children because there's nothing more satisfying for a mom to see her child’s face when taking the first bite of their homemade pastry&nbsp;and find out it does taste as good as it looks.</p>
                                            <p>&nbsp;</p>
                                            <p>Food for our children has become a means to an end. Less and less is homemade, especially sweet treats like pastries. Are pastries from the grocery store the way we want to show our kids how we love and care for them? Do you remember the times when you got back home from school and the whole house smelled like fresh baked pastries, you immediately smiled all over your face because you knew <font color="#089afc">that someone cared about you</font>. Taking that first bite of your favorite cupcake you felt the love your mother put into it.</p>
                                            <p>&nbsp;</p>
                                            <p>But it’s not your fault, you have demands on your life, you’re super busy, we now live in a two-parent workforce and you’re already stressed out at the mere thought of how your kitchen will look like afterwards, <font color="#089afc">who has time to bake ?</font>
                                            </p>
                                            <p>&nbsp;</p>
                                            <p>But don’t worry, we’re here to help you! Our baking tools are made of the highest quality materials focusing on making your life in the kitchen easier while your kitchen will stay clean and neat while doing that. And you know what? You will spend less time in the kitchen and spend more time <font color="#089afc">enjoying your delicious baked goods with your loved ones</font>.</p>
                                            <p>&nbsp;</p>
                                            <p>BAKE ON!</p>
                                            <p>Kevin &amp; Patrick</p> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
        <!--                     <div id="pg-14-2" class="panel-grid panel-no-style">
                                <div id="pgc-14-2-0" class="panel-grid-cell">
                                    <div id="panel-14-2-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="2">
                                        <div class="textwidget">
                                            <div style="text-align: center;"><strong>Follow KPKitchen</strong>
                                            </div>
                                            <div style="text-align: center;">&nbsp;</div>
                                            <div style="text-align: center;"><strong>Facebook - <a title="Bear KompleX" href="https://www.facebook.com/kpkitchenofficial/" target="_blank" rel="noopener noreferrer">facebook.com/kpkitchenofficial</a></strong>
                                            </div>
                                            <div style="text-align: center;"><strong>Instagram - (@KPKitchen) <a title="Bear KompleX Instagram" href="https://instagram.com/kpkitchen.eu/" target="_blank" rel="noopener noreferrer">instagram.com/kpkitchen.eu</a></strong>
                                            </div>
                                            <div style="text-align: center;"><strong>Pinterest - (@KPKitchen) <a title="Bear KompleX Twitter" href="https://pinterest.com/kpkitchen0100" target="_blank" rel="noopener noreferrer">pinterest.com/kpkitchen0100</a></strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!-- .entry-content -->
                </article>
                <!-- #post-## -->
            </main>
            <!-- #main -->
        </div>
        <!-- #primary -->
    </div>
</template>
<style type="text/css" media="all" id="siteorigin-panels-layouts-head">
    /* Layout 14 */
    #pgc-14-0-0,
    #pgc-14-1-0,
    #pgc-14-2-0 {
        width: 100%;
        width: calc(100% - (0 * 30px))
    }
    #pl-14 #panel-14-0-0-0,
    #pl-14 #panel-14-1-0-0,
    #pl-14 #panel-14-2-0-0 {} #pg-14-0,
    #pg-14-1,
    #pl-14 .so-panel {
        margin-bottom: 30px
    }
    #pl-14 .so-panel:last-child {
        margin-bottom: 0px
    }
    #pg-14-0.panel-no-style,
    #pg-14-0.panel-has-style > .panel-row-style,
    #pg-14-1.panel-no-style,
    #pg-14-1.panel-has-style > .panel-row-style,
    #pg-14-2.panel-no-style,
    #pg-14-2.panel-has-style > .panel-row-style {
        -webkit-align-items: flex-start;
        align-items: flex-start
    }
    @media (max-width: 780px) {
        #pg-14-0.panel-no-style,
        #pg-14-0.panel-has-style > .panel-row-style,
        #pg-14-1.panel-no-style,
        #pg-14-1.panel-has-style > .panel-row-style,
        #pg-14-2.panel-no-style,
        #pg-14-2.panel-has-style > .panel-row-style {
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column
        }
        #pg-14-0 .panel-grid-cell,
        #pg-14-1 .panel-grid-cell,
        #pg-14-2 .panel-grid-cell {
            margin-right: 0
        }
        #pg-14-0 .panel-grid-cell,
        #pg-14-1 .panel-grid-cell,
        #pg-14-2 .panel-grid-cell {
            width: 100%
        }
        #pl-14 .panel-grid-cell {
            padding: 0
        }
        #pl-14 .panel-grid .panel-grid-cell-empty {
            display: none
        }
        #pl-14 .panel-grid .panel-grid-cell-mobile-last {
            margin-bottom: 0px
        }
    }
</style>
<script>
    import api from '../api.js'
    export
    default {
        data() {
            return {
                title: "",
                content:"",
            }
        },
        async mounted() {
            const res = await api.get('/api/article/1')
            this.title = res.data.message.item.title;
            this.content = res.data.message.item.content;
        },
        methods: {

        },
    }
</script>



// WEBPACK FOOTER //
// src/components/About.vue